import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { classNames } from 'utils/utils'
import { mockEvent } from 'utils/events'
import { isEmpty } from 'ramda'

import { Input } from 'antd'
import { Icon } from 'components/patterns'
import withInputStyle from 'components/deprecated/Inputs/Input.style'
import withStyle, { SearchIcon } from './SearchInput.style'

const SearchInput = ({
  className,
  value,
  id,
  placeholder,
  onChange,
  onClear,
  width,
  onSearch,
  disabled,
  maxLength,
}) => {
  const ActionButtons = () => (
    <>
      <SearchIcon
        icon="search"
        hoverFill={'blueSecondary'}
        onClick={() => onSearch(mockEvent(value))}
        disabled={disabled}
      />
      {!isEmpty(value) && (
        <Icon
          icon="cancel"
          hoverFill={'blueSecondary'}
          onClick={() => onClear()}
        />
      )}
    </>
  )
  return (
    <div className={classNames(className, 'SearchInput')}>
      <Input
        id={id}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        width={width}
        type="search"
        onPressEnter={onSearch}
        addonAfter={<ActionButtons />}
        maxLength={maxLength}
      />
    </div>
  )
}

SearchInput.defaultProps = {
  value: '',
  placeholder: strings.enter_search_term,
  size: 'default',
  maxLength: 80,
}

SearchInput.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  clear: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSearch: PropTypes.func,
  onClear: PropTypes.func,
  size: PropTypes.string,
  rule: PropTypes.object,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  maxLength: PropTypes.number,
}

export default withInputStyle(withStyle(SearchInput))
